import React from 'react';
import { useDashTheme } from '../../DashboardV2/hooks/useDashTheme';
import { StatStrip } from '../../DashboardV2/components/StatStrip';
import { Button } from '../../DashboardV2/components/primitives';

// Header + KPI strip for the Team Goals tab — same StatStrip used on
// Projects/Team so this reads as one product instead of a bolted-on module.
const TeamMembersHeader = ({
  totalMembers = 0,
  submittedCount = 0,
  notSubmittedCount = 0,
  teamAvgScore = '0.0',
  reporteeScope = 'direct',
  setReporteeScope = () => {},
  showScopeToggle = false,
}) => {
  const t = useDashTheme();

  const submissionRate = totalMembers > 0 ? Math.round((submittedCount / totalMembers) * 100) : 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: t.s[3] }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: t.s[3], flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ fontSize: t.font.size["2xl"], fontWeight: t.font.weight.semibold, color: t.c.text, letterSpacing: '-0.01em' }}>
            Team Goals
          </h1>
          <p style={{ fontSize: t.font.size.sm, color: t.c.textTertiary, marginTop: 2 }}>
            Monitor your team's goal submissions and performance
          </p>
        </div>

        {showScopeToggle && (
          <div role="tablist" aria-label="Reportee scope" style={{ display: 'inline-flex', gap: 4, padding: 3, borderRadius: t.r.md, background: t.c.surfaceMuted, border: `1px solid ${t.c.border}` }}>
            {[{ key: 'direct', label: 'Direct' }, { key: 'all', label: 'Direct + Indirect' }].map((opt) => (
              <Button
                key={opt.key}
                size="sm"
                variant="ghost"
                active={reporteeScope === opt.key}
                role="tab"
                aria-selected={reporteeScope === opt.key}
                onClick={() => setReporteeScope(opt.key)}
              >
                {opt.label}
              </Button>
            ))}
          </div>
        )}
      </div>

      <StatStrip items={[
        { label: 'members', value: totalMembers, accent: t.accents[0] },
        { label: `submitted${totalMembers > 0 ? ` · ${submissionRate}%` : ''}`, value: submittedCount, accent: t.accents[1] },
        { label: 'pending review', value: notSubmittedCount, accent: t.accents[4] },
        { label: 'avg score', value: `${teamAvgScore}/10`, accent: t.accents[2] },
      ]} />
    </div>
  );
};

export default TeamMembersHeader;
